import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { MeProvider, useMe } from "@/lib/api";
import { Toaster } from "@/components/ui/sonner";
import AppShell from "@/components/AppShell";
import AuthLayout from "@/components/AuthLayout";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import InterviewSetup from "@/pages/InterviewSetup";
import InterviewRoom from "@/pages/InterviewRoom";
import SessionResult from "@/pages/SessionResult";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminQuestions from "@/pages/admin/AdminQuestions";
import AdminSessions from "@/pages/admin/AdminSessions";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminSettings from "@/pages/admin/AdminSettings";

const Protected = ({ children, admin }) => (
  <>
    <Show when="signed-in"><AdminGate admin={admin}>{children}</AdminGate></Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

function AdminGate({ admin, children }) {
  const { me, loading } = useMe();
  if (loading) return <div className="p-12 font-mono text-xs text-slate-500" data-testid="loading-me">LOADING PROFILE...</div>;
  if (admin && me?.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <AppShell>{children}</AppShell>;
}

const Home = () => (
  <>
    <Show when="signed-out"><Landing /></Show>
    <Show when="signed-in"><Navigate to="/dashboard" replace /></Show>
  </>
);

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <ClerkAuthProvider>
          <MeProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/sign-in/*" element={<AuthLayout><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthLayout>} />
              <Route path="/sign-up/*" element={<AuthLayout><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthLayout>} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/interview/new" element={<Protected><InterviewSetup /></Protected>} />
              <Route path="/interview/:id" element={<Protected><InterviewRoom /></Protected>} />
              <Route path="/sessions/:id" element={<Protected><SessionResult /></Protected>} />
              <Route path="/admin" element={<Protected admin><AdminOverview /></Protected>} />
              <Route path="/admin/questions" element={<Protected admin><AdminQuestions /></Protected>} />
              <Route path="/admin/sessions" element={<Protected admin><AdminSessions /></Protected>} />
              <Route path="/admin/sessions/:id" element={<Protected admin><SessionResult admin /></Protected>} />
              <Route path="/admin/users" element={<Protected admin><AdminUsers /></Protected>} />
              <Route path="/admin/settings" element={<Protected admin><AdminSettings /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </MeProvider>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
